<template>
  <form action="/register/personal_free_plan/final_confirm" method="post">
  <input type="hidden" name="_token" :value="csrfToken">
    <v-layout row>
      <v-flex xs12>
        <p class="summary paid-txt" v-if="reasons.length != 0">プレミアム会員、解約の理由を選択してください（複数回答可、必須）</p>
        <div>
          <v-checkbox
            name="cancel_reasons[]"
            v-for="reason in reasons"
            :key="reason.id"
            :label="reason.reason"
            :value="reason.id"
            v-model="checkFlg"
          ></v-checkbox>
          <span class="registerFeedback" role="alert" v-if="errorWithReason">
            <strong>{{ errorWithReason }}</strong>
          </span>
          <br>
          <v-textarea
            name="other"
            label="自由記入欄：その他解約事由について　今後の参考としたくご記載いただければ幸いです。（255文字以内でお願いします。）"
            :value="messageValue"
            :error-messages="errorWithMessage"
            class="message-area"
          ></v-textarea>
        </div>
      </v-flex>
    </v-layout>
    <input type="hidden" name="reason_count" :value="reasons.length">
    <v-layout row>
      <v-flex xs12 text-xs-center>
        <a href="/register/personal_free_plan/first_confirm" class="v-btn theme--light">戻る</a>
        <v-btn type="submit" class="btn-save" :disabled="reasons.length != 0 && checkFlg.length == 0">次へ</v-btn>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
  export default {
    props: [
        'reasons',
        'messageValue',
        'errorWithReason',
        'errorWithMessage'
    ],

    data () {
      return {
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        checkFlg: []
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  .v-input.message-area label.v-label {
    max-width: 100%;
    left: 0px;
    overflow: inherit;
    height: auto;
    white-space: break-spaces;
  }
</style>